import { MicroviewCommunicationChannel } from '../MicroviewCommunicationChannel';

export class TelemetryChannel extends MicroviewCommunicationChannel<
  {
    bag: Object;
    type: TelemetryType;
    skipClearSearchFlowId?: boolean;
  },
  void
> {
  public namespace: string = 'VPC.Telemetry';
  public name: string = 'TelemetryChannel';
}

export enum TelemetryType {
  ClickSearchResult = 'ClickSearchResult',
  ClickSearchResultDirectlyToTelemetryService = 'ClickSearchResultDirectlyToTelemetryService',
  FilterSearch = 'FilterSearch',
  SortSearch = 'SortSearch',
  SearchInitiated = 'SearchInitiated',
  SearchTermUpdate = 'SearchTermUpdate',
  SearchEPT = 'SearchEPT',
  SearchNoResult = 'SearchNoResult',
  SearchImpression = 'SearchImpression',
  SearchFiltersUpdated = 'SearchFiltersUpdated',
}
